module.exports = __webpack_public_path__ + "static/media/oreo.6f18aea6.png";